import http from '../../../http'
import Vue from 'vue'

const actions = {
    download: ({commit}, payload)=>{
        let token = window.sessionStorage.getItem('wh-access-token')
        http.request('/supplier-resource/order/download',"post","bolb", {no:payload.no}).then((res)=>{
            if (res.status === 200) {
                if (res.data === '') {
                    Vue.prototype.$message({
                        message: '下载失败,文件不存在！',
                        type: 'error'
                    });
                    return false;
                } else {
                    const blob2 = res.data;
                    let blob = new Blob([res.data], {type: 'application/zip'});
                    const contentDisposition = res.headers['content-disposition'];
                    let fileName = 'unknown';
                    if (contentDisposition) {
                        fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1]);
                    }
                    const link = document.createElement('a');
                    link.href = "http://supplier.craneweihua.com/supplier-resource/order/download?no="+payload.no+"&access_token="+token;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click(); // 点击下载
                    window.setTimeout(function () {
                        URL.revokeObjectURL(blob);
                        document.body.removeChild(link);
                    }, 0);
                }
            }
        })
    },
    getOrderList: ({commit}, payload)=>{
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/order/getOrderList', payload).then((res)=>{
                if(res.data && res.data.code === '200' ) {
                    resolve(res.data.data);
                }
            })
        })
    },

    getOrderDetailList: ({commit}, payload)=>{
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/order/getOrderDetailList', payload).then((res)=>{
                if(res.data && res.data.code === '200' ) {
                    resolve(res.data.data);
                }
            })
        })
    },

    getReviewOrderDetailList: ({commit}, payload)=>{
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/order/getReviewOrderDetailList', payload).then((res)=>{
                if(res.data && res.data.code === '200' ) {
                    resolve(res.data.data);
                }
            })
        })
    },

    modifyOrderDetail: ({commit}, payload)=>{
        let param = {};
        param.sOrdersDetailId = payload.id;
        param.expectDate = payload.expectDate;
        param.price = payload.price;
        param.vendorRemark = payload.vendorRemark;
        if(payload.ordersDetailModifyStatus === 0){
            param.id = payload.ordersDetailModifyId;
            param.status = 0;
        }
        return new Promise((resolve) => {
            http.post('/supplier-resource/order/modifyOrderDetail', param).then((res) => {
                if (res.data.code === '200') {
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            });
        });
    },

    acceptOrderDetailModify: ({commit}, payload)=>{
        let param = {};
        param.sOrdersDetailId = payload.id;
        param.expectDate = payload.expectDate;
        param.price = payload.price;
        param.vendorRemark = payload.vendorRemark;
        param.status = 2;
        param.orderNo = payload.orderNo;
        param.rowNo = payload.rowNo;
        return new Promise((resolve) => {
            http.post('/supplier-resource/order/modifyOrderDetail', param).then((res) => {
                if (res.data.code === '200') {
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            });
        });
    },

    submitOrderDetail: ({commit}, payload)=>{
        let param = {};
        param.sOrdersDetailId = payload.id;
        param.expectDate = payload.expectDate;
        param.price = payload.price;
        param.vendorRemark = payload.vendorRemark;
        param.status = 1;
        param.orderNo = payload.orderNo;
        param.rowNo = payload.rowNo;
        if(payload.ordersDetailModifyStatus === 0){
            param.id = payload.ordersDetailModifyId;
        }
        return new Promise((resolve) => {
            http.post('/supplier-resource/order/modifyOrderDetail', param).then((res) => {
                if (res.data.code === '200') {
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            });
        });
    },

    submitToSap: ({commit}, payload) => {
        return new Promise((resolve => {
            http.post('/supplier-resource/sp/push/order', {orderId: payload}).then((res)=>{
                resolve(res.data);
            })
        }))
    },

    exportExcel({commit, state}, payload) {
        let params = {};
        params.orderId = payload.orderId;
        http.download('/supplier-resource/order/exportExcel', 'get', params);
    },

    listOrdersDetailModify({commit, rootState}, payload) {
        return new Promise((resolve)=>{
            http.post('/supplier-resource/order/listOrdersDetailModify', {sOrdersDetailId: payload.sOrdersDetailId}).then((res) => {
                if (res.data.code === '200') {
                    commit('SET_DETAIL_MODIFY_LIST', res.data.data)
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            });
        })
    },


    setVendorSignInfo({commit}, payload) {
        return new Promise((resolve)=>{
            http.post('/supplier-resource/order/setVendorSignInfo',payload).then((res)=>{
                if(res.data.code === '200'){
                    resolve(res.data);
                }else{
                    resolve(res);
                }
            })
        })
    },

    cancelSign({commit}, payload) {
        return new Promise((resolve)=>{
            http.post('/supplier-resource/order/cancelSign',payload).then((res)=>{
                resolve(res);
            })
        })
    },


    getDOList: ({commit}, payload)=>{
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/order/getDOList', payload).then((res)=>{
                if(res.data && res.data.code === '200' ) {
                    resolve(res.data.data);
                }
            })
        })
    },

    getDODetailList: ({commit}, payload)=>{
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/order/getDODetailList', payload).then((res)=>{
                if(res.data && res.data.code === '200' ) {
                    resolve(res.data.data);
                }
            })
        })
    },

    preSendOrderDetailSummary({commit}, params) {
        return new Promise((resolve) => {
            http.post('/supplier-resource/order/preSendOrderDetailSummary', params).then((res) => {
                resolve(res.data);
            });
        });
    },



};

export default {
    namespaced: true,
    actions
};
